import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { DS } from './designTokens';
import { statusColor } from './formUtils';

interface JournalHeaderProps {
  title: string;
  status: string;
  formStatus: string;
  onBack: () => void;
}

const JournalHeader: React.FC<JournalHeaderProps> = ({
  title,
  status,
  formStatus,
  onBack,
}) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      mb: 2,
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <IconButton onClick={onBack} size="small" sx={{ color: DS.inkSecondary }}>
        <ArrowBackIcon fontSize="small" />
      </IconButton>
      <Typography
        sx={{
          fontFamily: DS.fontDisplay,
          fontWeight: 600,
          fontSize: '18px',
          color: DS.softBlack,
        }}
      >
        {title}
      </Typography>
    </Box>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
      <Box
        sx={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          backgroundColor: statusColor(status),
        }}
      />
      <Typography
        sx={{
          fontSize: '13px',
          color: DS.inkSecondary,
          fontFamily: DS.fontBody,
        }}
      >
        {formStatus}
      </Typography>
    </Box>
  </Box>
);

export default JournalHeader;
